// src/context/EstructuraContext.jsx
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback
} from 'react';
import { obtenerEstructuraCompleta } from '../services/api';

const EstructuraContext = createContext();

export function EstructuraProvider({ children }) {
  const [campos, setCampos] = useState([]);
  const [campoSeleccionado, setCampoSeleccionado] = useState(null);
  const [equipos, setEquipos] = useState([]);
  const [mensaje, setMensaje] = useState(null);
  const [userName, setUserName] = useState('Usuario');
  const [modalEquipoSeleccionado, setModalEquipoSeleccionado] = useState(null);

  // Carga usuario una sola vez
  useEffect(() => {
    const u = sessionStorage.getItem('userName');
    if (u) setUserName(u);
  }, []);

  // Función estable (memoizada) para cargar la estructura
  const cargarEstructura = useCallback(async () => {
    try {
      const data = window.api?.obtenerEstructura
        ? await window.api.obtenerEstructura(1)
        : await obtenerEstructuraCompleta();

      if (data?.estado && data.datos?.length > 0) {
        const struct = data.datos[0];
        setCampos(struct.campos || []);

        // Seleccionar inicial
        const guardado = parseInt(sessionStorage.getItem('campoSeleccionadoId'), 10);
        const inicial =
          struct.campos.find(c => c.campoId === guardado) ||
          struct.campos[0] ||
          null;

        setCampoSeleccionado(inicial);
        setMensaje(null);
      } else {
        setMensaje('❌ No se encontraron datos en la estructura');
      }
    } catch (err) {
      console.error(err);
      setMensaje('❌ Error al leer la estructura');
    }
  }, []);

  // Al montar provider carga la estructura
  useEffect(() => {
    cargarEstructura();
  }, [cargarEstructura]);

  // Cuando cambia el campo, actualiza equipos y guarda en session
  useEffect(() => {
    if (campoSeleccionado) {
      setEquipos(campoSeleccionado.modulos || []);
      sessionStorage.setItem(
        'campoSeleccionadoId',
        campoSeleccionado.campoId.toString()
      );
    }
  }, [campoSeleccionado]);

  // Logout
  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = '/';
  };

  return (
    <EstructuraContext.Provider
      value={{
        campos,
        campoSeleccionado,
        setCampoSeleccionado,
        equipos,
        mensaje,
        userName,
        handleLogout,
        modalEquipoSeleccionado,
        setModalEquipoSeleccionado
      }}
    >
      {children}
    </EstructuraContext.Provider>
  );
}

export function useEstructura() {
  return useContext(EstructuraContext);
}
